<script>
import iconHasGot from '@/images/cms/coupons/stamp_received@2x.png'
import iconNoStock from '@/images/cms/coupons/stamp_none@2x.png'

export default {
  functional: true,
  render(h, { props, listeners }) {
    const statusText =
      props.stockStatus === 0
        ? ''
        : props.stockStatus === 1
        ? '已经领过啦～'
        : '已经抢光啦～'

    const stamp =
      props.stockStatus === 1
        ? iconHasGot
        : props.stockStatus === 2
        ? iconNoStock
        : ''

    const showReceiveBtn = props.canGet

    return (
      <div
        class={`coupon2N ${props.stockStatus === 2 ? 'soldout' : ''}`}
        style={props.couponStyle}
      >
        <div class="left">
          <p class="coupon-value">
            <span class="symbol">￥</span>
            <span class="value">{props.couponValue}</span>
          </p>
          <p class="threshold">{props.thresholdMsg}</p>
        </div>
        <div class="right">
          <div class="name">{props.couponName}</div>
          <p class="status-text">{statusText}</p>
          {showReceiveBtn ? (
            <div class="action" onClick={listeners['receive-coupon']}>
              <p>立即领取</p>
            </div>
          ) : (
            stamp && <img class="stamp" src={stamp} />
          )}
        </div>
      </div>
    )
  }
}
</script>

<style lang="scss" scoped>
@mixin cross_line($height, $line_color) {
  &::before {
    position: absolute;
    top: 0;

    width: 100%;
    height: $height;
    margin: 4px 0px;

    border-right: 1px dashed $line_color;

    content: '';
  }
}
.coupon2N {
  height: 1.68rem;

  overflow: hidden;

  border-radius: 0.16rem;

  flex: none;
  box-sizing: border-box;

  background-size: 100% 1.7rem;

  @include coupon-bg-width-circle(#fff8f5, 1.46rem, 1.68rem, 0.1rem, 0.02rem);
  @include flex(row, flex-start, stretch, nowrap);

  .left {
    position: relative;

    width: 1.46rem;

    flex: none;

    @include flex(column, center, stretch, nowrap);

    &::before {
      position: absolute;
      top: 0;

      width: 100%;
      height: 1.52rem;
      margin: 0.08rem 0;

      border-right: 1px dashed #ffd5be;

      content: '';
    }

    .coupon-value {
      @include flex(row, center, flex-end, nowrap);

      .symbol,
      .value {
        position: relative;
        bottom: 0.04rem;

        flex: none;

        font-size: 0.32rem;
        color: #ff5c00;
      }

      .symbol {
        line-height: 0.4rem;
      }

      .value {
        margin-left: -1px;

        font-size: 0.56rem;
        font-weight: 600;
      }
    }

    .threshold {
      margin-top: 0.08rem;

      font-size: 0.22rem;
      line-height: 0.32rem;
      text-align: center;
      color: #ff5c00;
      @include text-overflow-ellipsis-single;
    }
  }
  .right {
    position: relative;

    padding: 0.2rem 0.2rem 0.4rem;

    overflow: hidden;

    flex: auto;

    @include flex(column, space-between, flex-start, nowrap);

    .name {
      font-size: 0.24rem;
      line-height: 0.3rem;
      font-weight: $fw-semi-bold;
      color: $c-text-normal;

      @include text-overflow-ellipsis-multiple;
    }

    .status-text {
      z-index: 9;

      font-size: 0.24rem;
      line-height: 0.32rem;
      color: #999999;
      @include text-overflow-ellipsis-single;
    }

    .action {
      position: absolute;
      bottom: 0.26rem;
      left: 0.2rem;

      width: 1.44rem;
      height: 0.44rem;

      background-image: linear-gradient(to right, #ff7d00, #ff5c00);

      border-radius: 0.22rem;

      @include flex-row-center;

      p {
        font-size: 0.22rem;

        color: #fff;
      }
    }

    .stamp {
      position: absolute;
      right: -0.04rem;
      bottom: -0.3rem;

      width: 1.04rem;
    }
  }

  &.soldout {
    @include coupon-bg-width-circle(#f3f3f3, 1.46rem, 1.68rem, 0.1rem, 0.02rem);
    .left {
      @include cross_line(1.52rem, #e2e2e2);

      .coupon-value {
        .symbol,
        .value {
          color: #999;
        }
      }
      .threshold {
        color: #999;
      }
    }

    .right {
      .info {
        .name {
          color: $c-text-light;
        }
      }
    }
  }
}
</style>
